import Vue from 'vue'
import {
  Form,
  Button,
  FormItem,
  Drawer,
  Header,
  Container,
  Card,
  Message,
  Input,
  Timeline,
  TimelineItem,
  Avatar,
  DescriptionsItem,
  Descriptions,
  Tag,
  Progress,
  Empty,
  Tooltip,
  Divider,
  Switch
} from 'element-ui'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Drawer)
Vue.use(Header)
Vue.use(Container)
Vue.use(Card)
Vue.use(Input)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Avatar)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Tag)
Vue.use(Progress)
Vue.use(Empty)
Vue.use(Tooltip)
Vue.use(Divider)
Vue.use(Switch)
Vue.prototype.$message = Message
